<script>
import { mapGetters, mapActions } from "vuex";

import genders from "../service/genders";
import AdminAppShowDetail from "./AdminAppShowDetail.vue";
import AdminAppShowPhoto from "./AdminAppShowPhoto.vue";
import AdminAppPaidShowItem from "~/src/components/AdminAppPaid2023ShowItem.vue";
import AppConfirm from "~/src/components/modals/app-confirm.vue";

export default {
  components: {
    AdminAppPaidShowItem,
    AdminAppShowDetail,
    AdminAppShowPhoto,
    AppConfirm,
  },
  data: () => ({
    genders,
    photo: null,
    paidDialog: false,
  }),

  computed: {
    ...mapGetters("admin-contracts2023", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSuperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
  },

  methods: {
    ...mapActions("admin-contracts2023", ["INIT_BY_ID"]),
    ...mapActions("admin-contracts2023", ["PAID_APPLICATION"]),

    onConvert() {
      this.PAID_APPLICATION({ id: this.application.id }).then((status) => {
        if (status) {
          this.$router.replace("/contract_2024_2025");
        }
      });
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },

    getGender(id) {
      return this.genders.find((x) => x.id == id) || {};
    },

    async onRefreshPayments() {
      this.$store.dispatch("SET_LOADING", true);
      const id = this.$route.params.id;
      await this.INIT_BY_ID({ id });
      this.$store.dispatch("SET_LOADING", false);
    },
  },
};
</script>

<template>
  <div>
    <v-form @submit.prevent="() => false" ref="form" lazy-validation>
      <v-row>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('First name')"
              :text="application.firstName"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Last name')"
              :text="application.lastName"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Middle name')"
              :text="application.middleName"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Gender')"
              :text="getGender(application.gender)[`name-${$i18n.locale}`]"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Date of birth')"
              :text="application.birthDate"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Kurs')"
              :text="application.kurs"
            />
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <div>
              <div class="-title" v-text="$t('Country')" />
              <div class="-text" v-text="application.country.name" />
            </div>
            <div class="pt-4">
              <div class="-title" v-text="$t('Region')" />
              <div class="-text" v-text="application.region.name" />
            </div>
            <div class="pt-4">
              <div class="-title" v-text="$t('City / District')" />
              <div class="-text" v-text="application.city.name" />
            </div>

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Address')"
              :text="application.addressLine"
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Citizenship')"
              :text="application.citizenship.name"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Nationality')"
              :text="application.nationality"
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <admin-app-show-detail :title="$t('Photo')" />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.photo"
            :url="$file(application.photo)"
          />
        </v-col>
      </v-row>

      <div class="pt-10" />
      <div class="text-center">
        <img src="@/assets/icons/devider.svg" alt="" />
      </div>
      <div class="pt-10" />

      <v-row>
        <v-col cols="12" md="3">
          <admin-app-show-detail :title="$t('Copy of the passport')" />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.passportPhoto"
            :url="$file(application.passportPhoto)"
          />
          <br />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.passportBackPhoto"
            :url="$file(application.passportBackPhoto)"
          />
        </v-col>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Passport series and number')"
              :text="application.passportNumber"
            />
            <br />
            <admin-app-show-detail
              :title="$t('jshir')"
              :text="application.pinflNumber"
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Home phone number')"
              :text="application.homePhone"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Personal phone number')"
              :text="application.mobilePhone"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Father\'s phone number')"
              :text="application.fatherPhone || '—'"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Mother\'s phone number')"
              :text="application.motherPhone || '—'"
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail :title="$t('Payments Info')" />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Contract Number')"
              :text="application.contractNumber"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Guruh kodi')"
              :text="application.groupCode"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Kontract summasi')"
              money :text="application.totalSumma"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Tolangan summasi')"
              money :text="application.totalPaidSumma"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Qoldiq')"
              money :text="application.totalOstatok"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Tolovlar ruyxati')"
            />
            <!--    <div
              v-for="(item, index) in application.paymentList"
              :key="index"
              class="-text"
              v-text="`${index + 1}. ${item.datePayment}-da ${item.paid} so'm`"
            />-->

            <admin-app-paid-show-item
              v-for="(item, index) in application.paymentList"
              @refresh="onRefreshPayments"
              :key="index"
              :item-data="item"
              :label="`${index + 1}. ${formatDate(item.datePayment)}-da ${
                item.paid
              } so'm${item.comment ? ' — ' + item.comment : ''}`"
            />

            <div v-if="!application.paymentList.length">—</div>
          </div>
        </v-col>
      </v-row>

      <div class="pt-10" />
      <div class="text-center">
        <img src="@/assets/icons/devider.svg" alt="" />
      </div>
      <div class="pt-10" />
      <v-row>
        <v-col cols="12" md="4">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Disability status')"
              :text="application.disability.name || '—'"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Disability note')"
              :text="application.disabilityNote || '—'"
            />
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="-data-wrap">
            <div>
              <admin-app-show-detail
                :title="$t('Graduated school / college / lyceum')"
                class="-title"
                :text="application.schoolName"
              />
            </div>

            <admin-app-show-detail
              class="pt-4"
              :title="$t('School type')"
              :text="application.schoolType.name"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Year of graduation')"
              :text="application.graduationYear"
            />
            <div>
              <admin-app-show-detail
                class="pt-4"
                :title="$t('Diploma / Certificate number')"
                :text="application.highSchoolDiplomaNumber"
              />
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="-data-wrap">
            <admin-app-show-detail
              v-model="application.reviews.highSchoolDiplomaPhoto"
              :title="$t('Copy of the Certificate / Diploma')"
            />
            <admin-app-show-photo
              class="pt-2"
              v-if="application.highSchoolDiplomaPhoto"
              :url="$file(application.highSchoolDiplomaPhoto)"
            />
          </div>
        </v-col>
      </v-row>

      <div class="pt-10" />
      <div class="text-center">
        <img src="@/assets/icons/devider.svg" alt="" />
      </div>
      <div class="pt-10" />

      <v-row>
        <v-col cols="12" md="4">
          <admin-app-show-detail
            v-model="application.reviews.foreignLanguageProficiencyPhoto"
            :title="$t('The result of the English language')"
          />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.foreignLanguageProficiencyPhoto"
            :url="$file(application.foreignLanguageProficiencyPhoto)"
          />
          <div v-else>—</div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Type')"
              :text="application.foreignLanguageProficiency.name || '—'"
            />
            <div
              v-if="
                application.foreignLanguageProficiency.id &&
                application.foreignLanguageProficiency.id == 6
              "
            >
              <admin-app-show-detail
                :title="$t('name_certificate')"
                class="pt-4"
                :text="application.certificateOther || '—'"
              />
            </div>

            <admin-app-show-detail
              :title="$t('Score')"
              class="pt-4"
              :text="application.score || '—'"
            />

            <admin-app-show-detail
              :title="$t('Certificate number')"
              class="pt-4"
              :text="application.certificateNumber || '—'"
            />
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="-data-wrap">

            <admin-app-show-detail
                :title="$t('Code of study')"
                class="pt-4"
                :text="(application?.facultyMvdir || '') + ' - ' + (application?.facultySchetType || 'GLOBAL')"
            />

            <admin-app-show-detail
              :title="$t('Field of study')"
              class="pt-4"
              :text="application.educationFaculty.name"
            />
            <admin-app-show-detail
              :title="$t('Type of education')"
              class="pt-4"
              :text="application.educationType.name"
            />
            <admin-app-show-detail
              :title="$t('Language of instruction')"
              class="pt-4"
              :text="application.educationLanguage.name"
            />
          </div>
        </v-col>
        <v-col cols="12" md="4" v-if="application.dtmScore">
          <div class="-data-wrap">
            <admin-app-show-detail :title="$t('DTM Test Paper Result')" />
            <admin-app-show-photo
              class="pt-2"
              v-if="application.dtmAbiturientPhoto"
              :url="$file(application.dtmAbiturientPhoto)"
            />
            <div v-else>—</div>
          </div>
        </v-col>
        <v-col cols="12" md="4" v-if="application.dtmScore">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Total score')"
              class="pt-4"
              :text="application.dtmScore"
            />
            <admin-app-show-detail
              :title="$t('Applicant ID number')"
              class="pt-4"
              :text="application.dtmAbiturientNumber"
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="d-flex pt-10">
            <v-spacer />
            <v-btn
              v-if="
                isSuperAdmin &&
                application.paidStatus == 'PAID' &&
                !application.converted
              "
              @click="paidDialog = true"
              color="accent"
              class="ml-3"
            >
              {{ $t("convert") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>

    <app-confirm v-model="paidDialog" :text="$t('paid?')" @accept="onConvert" />
  </div>
</template>

<style lang="scss" scoped>
.-data-wrap {
  height: 100%;
  border-left: 1px solid rgba(128, 128, 128, 0.699);

  padding-left: 15px;
}

.-title {
  font-size: 14px;
}

.-text {
  font-weight: 500;
}
</style>
